import {jsx} from 'panel';

import {isFirstTimeEventFilter} from 'common/widgets/property-filter-menu/models/utils';

import type {QueryEntrySection} from '../index';
import {QueryEntrySectionEl} from '../row-types/base/query-entry-section-el';
import {
  EntryPart,
  EntrySectionUpdateEvent,
  FiltersOperator,
  QueryFilterEntry,
  QueryMetricEntry,
  RowLabelType,
  SelectorTypeDefinitions,
} from '../types';

export function RowFilters({
  el,
  entry,
  index,
  source,
  handleUpdate,
}: {
  el: QueryEntrySection;
  entry: QueryMetricEntry;
  index: number;
  source: EntryPart;
  handleUpdate: (ev: EntrySectionUpdateEvent) => void;
}) {
  const {placeholders} = el.state;
  const {event} = entry;
  const showPlaceholder = placeholders.get(index) === source;
  const filters = el.helpers.getEntryFilters(index)[source];

  const filterEntries = filters.map((filter) => ({
    type: SelectorTypeDefinitions.Filter,
    event: filter,
    filtersOperator: entry.filtersOperator || FiltersOperator.And,
  })) as QueryFilterEntry[];

  if (filters.length === 0 && !showPlaceholder) {
    return null;
  }

  return (
    <QueryEntrySectionEl
      attrs={{
        ...el.helpers.getNestedSectionAttrs(),
        elref: el.helpers.camelCase(
          `entry-${source}`,
        ) /* entryFilters or entryBehavioralFilters, depending on source */,
        'event-names': event && event.value ? [event.value] : [],
        'disable-add-entry': true,
        'can-rename-step': false,
        'row-types': [SelectorTypeDefinitions.Filter],
        'disable-clone-entry': filters.some((filter) => isFirstTimeEventFilter(filter)),
        'row-label-type': RowLabelType.None,
        'hide-events': !el.helpers.isEventBasedType(entry.type),
        'project-has-cohorts': el.attr(`project-has-cohorts`) && el.attr(`allow-cohort-filter`),
        entries: filterEntries,
      }}
      props={{
        isStagingRow: showPlaceholder && {filtersOperator: filterEntries[0]?.filtersOperator || FiltersOperator.And},
      }}
      on={{
        update: handleUpdate,
        abortStage: () => el.helpers.setActiveEntry(`close`, index, source),
      }}
    />
  );
}
